import { createContext, ReactNode, useContext } from "react";

import type { CourseRelationsActions } from "src/components/CourseTree/types";

const defaultActions: CourseRelationsActions = {
  toggleCourseVisibility: () => undefined,
  deleteRelation: () => undefined,
  nodeClicked: () => undefined,
  isSuperAdmin: () => false,
};

const CourseRelationsContext = createContext<CourseRelationsActions>(defaultActions);

CourseRelationsContext.displayName = "CourseRelationsContext";

export const CourseRelationsContextProvider = ({
  actions,
  children,
}: {
  actions: CourseRelationsActions;
  children: ReactNode;
}) => <CourseRelationsContext.Provider value={actions}>{children}</CourseRelationsContext.Provider>;

export const useCourseRelationsContext = () => useContext(CourseRelationsContext);

export default CourseRelationsContext;
